<p-messages></p-messages>
<div class="m-2">
    <p>
        The task <strong>"{{ config.data!.itemToDelete.name }}"</strong> is used by other tasks. Removing it will change
        the workflow for the following dependent tasks:
    </p>
    <div style="max-height: 60vh; overflow-y: auto">
        @if (dependencies.length > 0) {
            <div class="m-2">
                <strong>Depends on parent tasks:</strong>
                <ul class="mt-2 pe-2 w-100">
                    <li *ngFor="let dependecy of dependencies" class="mb-1 d-flex align-items-center">
                        <div class="w-50">
                            {{ TreeUtils.findTreeNodeByKey(options, dependecy.depends_on_task_uuid)?.data?.name }}
                        </div>
                        <span class="px-5 text-nowrap">will trigger</span>
                        <div *ngIf="newDependencyControls.get(dependecy.depends_on_task_uuid)" class="w-50">
                            <p-treeSelect
                                [formControl]="newDependencyControls.get(dependecy.depends_on_task_uuid)!"
                                containerStyleClass="width-form"
                                [options]="options"
                                title="Select a new dependency affectation"
                                placeholder="No more link"
                                emptyMessage="No task found"
                                [filter]="true"
                                selectionMode="single"
                                [showClear]="true"
                                appendTo="body"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="35"
                                [virtualScrollOptions]="{scrollHeight: '20rem'}"
                            ></p-treeSelect>
                        </div>
                    </li>
                </ul>
            </div>
        }

        @if (dependents.length > 0) {
            <div class="m-2">
                <strong>Dependent child tasks:</strong>
                <ul class="mt-3 pe-2 w-100">
                    <li *ngFor="let dependent of dependents" class="mb-1 d-flex align-items-center">
                        <div *ngIf="newDependentsControls.get(dependent.task_uuid)" class="w-50">
                            <p-treeSelect
                                [formControl]="newDependentsControls.get(dependent.task_uuid)!"
                                containerStyleClass="width-form"
                                [options]="options"
                                title="Select a new dependency affectation"
                                placeholder="No more link"
                                emptyMessage="No task found"
                                [filter]="true"
                                selectionMode="single"
                                [showClear]="true"
                                appendTo="body"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="35"
                                [virtualScrollOptions]="{scrollHeight: '20rem'}"
                            ></p-treeSelect>
                        </div>
                        <span class="px-5 text-nowrap">will trigger</span>
                        <div class="w-50">
                            {{ TreeUtils.findTreeNodeByKey(options, dependent.task_uuid)?.data?.name }}
                        </div>
                    </li>
                </ul>
            </div>
        }
    </div>
    <p class="mt-2">
        <i class="pi pi-exclamation-triangle me-2" style="color: orange"></i>
        Are you sure you want to continue? Unassigned dependencies will be deleted.
    </p>
</div>
<div class="p-dialog-footer">
    <p-button severity="secondary" icon="pi pi-times" type="button" label="Cancel" (onClick)="onCancel()" />
    <p-button severity="primary" label="Continue" [loading]="showLoading" (onClick)="onConfirm()" />
</div>
